module.exports = __webpack_public_path__ + "static/media/uploadFile.8f6229a8.svg";